
export const getStackedItem = (stackedPrices, totalWeight) => {
  if (!stackedPrices) {
    return;
  }
  const { quantityPriceList } = stackedPrices;
  let quantityUnit = totalWeight;

  if (quantityPriceList && quantityPriceList.length) {
    let stackedItem;

    for (let priceListItem of quantityPriceList) {
      let quantity = priceListItem.quantity;

      if (quantityUnit < quantity) {
        break;
      }
      stackedItem = priceListItem;
    }

    return stackedItem ? stackedItem : quantityPriceList[0];
  }

  return null;
};
